import { locale } from '../../config.json'

/**
 * Formats the given number as a human readable string.
 *
 * @param {number} number
 * @param {number=} decimals
 * @return {string}
 */
export function formatNumber(number, decimals) {
  if (decimals !== undefined) {
    number = round(number, decimals)
  }

  return number.toLocaleString(locale)
}

/**
 * Formats the given number span as a string.
 *
 * @param {number|{min: number, max: number}}min
 * @param {number|undefined=} max
 * @param {number=} decimals
 * @return {string}
 */
export function formatSpan(min, max, decimals) {
  if (typeof min === 'object') {
    max = min.max
    min = min.min
  }

  if (min === max) {
    return formatNumber(min, decimals)
  }

  return `${formatNumber(min, decimals)}–${formatNumber(max, decimals)}`
}

/**
 * Rounds the given number to the given number of decimals.
 *
 * @param {number} number
 * @param {number=} decimals Defaults to 0
 * @returns {number}
 */
export function round(number, decimals = 0) {
  return Number(Math.round(`${number}e+${decimals}`) + `e-${decimals}`)
}
